import React, { useRef } from 'react';
import { useConfig } from '@hummingbirdtechgroup/wings-config';
import { getToken, saveToken, getTokenExpirationTime } from '../utils';
function scheduleNextRefresh(iframe, origin) {
    const token = getToken();
    const now = Math.floor(Date.now() / 1000);
    const tokenExpiresIn = Math.round((getTokenExpirationTime(token) - now) * 0.9);
    setTimeout(() => {
        iframe.current.contentWindow.postMessage({ type: 'get-token' }, origin);
    }, tokenExpiresIn * 1000);
}
function TokenRefresh() {
    const { accountsUrl } = useConfig();
    const iframe = useRef(null);
    const onLoad = () => {
        // schedule first token refresh
        scheduleNextRefresh(iframe, accountsUrl);
        window.addEventListener('message', e => {
            if (e.data && e.data.type === 'set-token') {
                saveToken(e.data.data);
                // schedule next token refresh
                scheduleNextRefresh(iframe, accountsUrl);
            }
        });
    };
    return (React.createElement("iframe", { ref: iframe, height: "1", title: "refresh", src: `${accountsUrl}refresh-token`, frameBorder: "0", onLoad: () => onLoad() }));
}
export default TokenRefresh;
//# sourceMappingURL=TokenRefresh.js.map